module.exports = __webpack_public_path__ + "img/blackjack.1891a70b.webp";